import { ArrowLeft, ArrowRight } from "lucide-react";

const INSPECTIONS = [
  { id: "1.0", label: "Condition of consumer's intake equipment (visual inspection only)" },
  { id: "2.0", label: "Parallel or switched alternative sources of supply" },
  { id: "3.0", label: "Protective measure: Automatic Disconnection of Supply (ADS)" },
  { id: "4.0", label: "Basic protection" },
  { id: "5.0", label: "Protective measures other than ADS" },
  { id: "6.0", label: "Additional protection" },
  { id: "7.0", label: "Distribution equipment" },
  { id: "8.0", label: "Circuits (Distribution and Final)" },
  { id: "9.0", label: "Isolation and switching" },
  { id: "10.0", label: "Current-using equipment (permanently connected)" },
  { id: "11.0", label: "Identification and notices" },
  { id: "12.0", label: "Location(s) containing a bath or shower" },
  { id: "13.0", label: "Other special installations or locations" },
  { id: "14.0", label: "Prosumer's low voltage electrical installation(s)" },
];

const OUTCOMES = [
  { value: "C1", label: "C1", color: "bg-red-500 text-white" },
  { value: "C2", label: "C2", color: "bg-orange-400 text-white" },
  { value: "C3", label: "C3", color: "bg-yellow-400 text-black" },
  { value: "Pass", label: "\u2713", color: "bg-emerald-500 text-white" },
  { value: "N/A", label: "N/A", color: "bg-[#E4E4E7] text-[#71717A]" },
];

export default function DomesticEICStep3({ formData, updateForm, onNext, onPrev }) {
  const inspections = formData.inspections || {};

  const setInspection = (id, value) => {
    updateForm({ inspections: { ...inspections, [id]: value } });
  };

  return (
    <div className="form-container max-w-3xl mx-auto" data-testid="eic-step-3">
      <h2 className="text-xl font-bold mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Schedule of Inspections
      </h2>
      <p className="text-xs text-[#71717A] mb-6">
        <span className="font-semibold text-emerald-600">{"\u2713"}</span> = Satisfactory &nbsp;|&nbsp;
        <span className="font-semibold text-[#71717A]">N/A</span> = Not applicable &nbsp;|&nbsp;
        <span className="font-semibold text-red-500">C1</span> = Danger present &nbsp;|&nbsp;
        <span className="font-semibold text-orange-400">C2</span> = Potentially dangerous &nbsp;|&nbsp;
        <span className="font-semibold text-yellow-500">C3</span> = Improvement recommended
      </p>

      <div className="space-y-0" data-testid="eic-inspections-list">
        {INSPECTIONS.map((item, idx) => (
          <div
            key={item.id}
            className={`flex items-center justify-between py-3 px-3 ${idx % 2 === 0 ? "bg-[#FAFAFA]" : "bg-white"} border-b border-[#E4E4E7]`}
            data-testid={`eic-inspection-${item.id}`}
          >
            <div className="flex-1 mr-4">
              <span className="text-xs font-bold text-[#00A3E0] mr-2">{item.id}</span>
              <span className="text-sm">{item.label}</span>
            </div>
            <div className="flex gap-1 flex-shrink-0">
              {OUTCOMES.map((o) => (
                <button
                  key={o.value}
                  type="button"
                  data-testid={`eic-insp-${item.id}-${o.value}`}
                  onClick={() => setInspection(item.id, o.value)}
                  className={`w-9 h-8 text-xs font-bold border-2 transition-all ${
                    inspections[item.id] === o.value
                      ? `${o.color} border-[#0A0A0A] scale-110`
                      : "bg-white text-[#B8B9BD] border-[#E4E4E7] hover:border-[#0A0A0A]"
                  }`}
                >
                  {o.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between mt-6">
        <button data-testid="eic-step-3-prev" onClick={onPrev} className="brutalist-btn-outline flex items-center gap-2">
          <ArrowLeft className="w-4 h-4" /> Previous
        </button>
        <button data-testid="eic-step-3-next" onClick={onNext} className="brutalist-btn flex items-center gap-2">
          Next <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
